import { Typography } from "@mui/material";
import { OverflowText } from "@verity/components/core";
import { ChoiceAnswer, MCOptionInstructor, TFOptionInstructor } from "@verity/api-client/types";
import CorrectIcon from "../../../../../images/quiz-question/option-correct-answer-checked-icon.svg?react";
import InCorrectIcon from "../../../../../images/quiz-question/option-inccorect-icon.svg?react";
import pageStyles from "../QuizResultPanel.module.css";
import styles from "./QuestionAnswer.module.css";
import { AnswerViewProps, CorrectAnswerViewProps, t } from "./shared";

/** Shared by MultipleChoice and TrueFalse — both store selected options as indices. */
export function MCAnswerView({ question, response }: AnswerViewProps) {
	const options = (question.options as MCOptionInstructor[] | TFOptionInstructor[] | undefined) ?? [];
	const selectedIndices: ChoiceAnswer = response?.isAnswered ? ((response.answer as ChoiceAnswer) ?? []) : [];

	return (
		<div className={styles.optionList}>
			{options.map((opt, idx) => {
				const isSelected = selectedIndices.includes(idx);
				const isCorrect = opt.weightage > 0;
				return (
					<div
						key={idx}
						className={`${styles.option} ${isSelected && isCorrect ? styles.correct : ""} ${isSelected && !isCorrect ? styles.incorrect : ""}`}
					>
						<div
							className={`${styles.optionIndexBox} ${isSelected && isCorrect ? styles.correct : ""} ${isSelected && !isCorrect ? styles.incorrect : ""}`}
						>
							{isSelected && isCorrect && <CorrectIcon />}
							{isSelected && !isCorrect && <InCorrectIcon />}
						</div>
						<OverflowText
							variant="body2"
							fontWeight={400}
							fontSize="14px"
							style={{
								flexGrow: 1,
								minWidth: 0,
							}}
						>
							{opt.text}
						</OverflowText>
					</div>
				);
			})}
		</div>
	);
}

export function MCCorrectAnswer({ question }: CorrectAnswerViewProps) {
	const options = (question.options as MCOptionInstructor[] | TFOptionInstructor[] | undefined) ?? [];
	const correct = options.map((opt, idx) => ({ opt, idx })).filter(({ opt }) => opt.weightage > 0);
	if (correct.length === 0) return null;
	// TrueFalse only has 2 options, so an "A./B." label (used for MultipleChoice) would be meaningless.
	const isTrueFalse = question.questionType === "TrueFalse";
	return (
		<div className={styles.correctAnswerSection}>
			<Typography className={pageStyles.sectionLabel}>{t("correctAnswer")}</Typography>
			<div className={styles.correctAnswerList}>
				{correct.map(({ opt, idx }) => (
					<Typography key={idx} className={styles.correctAnswerItem}>
						{isTrueFalse ? (
							opt.text
						) : (
							<>
								<span className={styles.correctAnswerLabel}>{String.fromCharCode(65 + idx)}.</span> {opt.text}
							</>
						)}
					</Typography>
				))}
			</div>
		</div>
	);
}
